import SignInRedirect from './SignInRedirect'

export default SignInRedirect
